// noinspection JSUnresolvedVariable,JSUnresolvedFunction
import {Load} from "./Load";
import {Display} from "./Display";
import {Observer} from "./Observer";
import {Overlay} from "./Overlay";
import {Audioplayer} from "./Audioplayer";
import {Video} from "./Video";

export class Basic
{
    static init()
    {
        Basic.base = document.body.dataset.base;
        Basic.lang = document.documentElement.lang;
        Basic.resizeTimer = 0;
        Basic.scrollTimer = 0;
        Basic.ise = (document.body.dataset.ise === 'on');
        Basic.sliders = {};
        Basic.navHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--nav-height'));
        Basic.v = {
        }
    }

    static add_changeEvent()
    {
        document.body.addEventListener('change',async e =>
        {
            let el = e.target;

            if(el.closest('.w__js-change'))
            {
                el = el.closest('.w__js-change');
            }

            if(el.classList.contains('w__js-change') &&
              !el.classList.contains('inactive') &&
               el.dataset.f)
            {
                switch(el.dataset.f)
                {
                    default:
                        console.log('Missing case change: ' + el.dataset.f);
                }
            }
        });
    }

    static add_clickEvent()
    {
        document.body.addEventListener('click',async e =>
        {
            let el = e.target;

            if(el.classList.contains('ise') || el.closest('.ise'))
            {
                return false;
            }
            else if(el.closest('.w__js-button'))
            {
                el = el.closest('.w__js-button');
            }

            if(el.classList.contains('w__js-button') &&
               el.dataset.f)
            {
                switch(el.dataset.f)
                {
                    case 'close-overlay':
                        e.preventDefault();
                        Overlay.close(el.href);
                        break;

                    case 'event-history':
                        await Basic.get_pastEvents(el);
                        break;

                    case 'open-overlay':
                        e.preventDefault();
                        await Overlay.open(el.href, el.dataset.type);
                        break;

                    case 'toggle-menu':
                        document.documentElement.classList.toggle('mod--menu-open');
                        break;

                    case 'video':
                        e.preventDefault();
                        new Video(el);
                        break;

                    default:
                        console.log('Missing case: ' + el.dataset.f);
                }
            }
            else if(el.closest('.w__menu'))
            {
                document.documentElement.classList.remove('mod--menu-open');
            }
        });
    }

    static do_afterLoad()
    {
        // add observer
        let firstModule, headerPhoto;

        if(Display.orientation === 'portrait')
        {
            firstModule = document.body.querySelector('.w__module .w__listen-to--figure');
        }
        else
        {
            firstModule = document.body.querySelector('.w__module:not(.mod--overlay)');
            headerPhoto =document.body.querySelector('.w__photo--figure');
        }

        if(firstModule)
        {
            new Observer(firstModule, document.body);
        }

        if(headerPhoto)
        {
            new Observer(document.body.querySelector('.w__quotation--figure'), headerPhoto);
        }

        const audios = document.body.querySelectorAll('.w__audio--player');
        for(let i=0; i<audios.length; i++)
        {
            new Audioplayer(audios[i]);
        }
    }

    static async get_pastEvents(el)
    {
        const container = el.closest('.w__module--inner');
        el.closest('.w__button--more-container').remove();

        try
        {
            const r = await Load.fetch({
                f: 'event-history',
                limitStart: el.dataset.limitStart,
                odd: el.dataset.odd === '1'
            });

            container.insertAdjacentHTML('beforeend', r['html']);
        }
        catch(error) {}
    }


    static async load_backgroundPage(url)
    {
        try
        {
            const r = await Load.fetch({
                url: url,
                f: 'background-page'
            });
            Overlay.remTitle = r['pageTitle'];
            document.body.insertAdjacentHTML('beforeend',r['html']);
            Basic.do_afterLoad();
        }
        catch(error) {}
    }

    static process_resize()
    {
    }

    static process_scroll()
    {
    }
}

